import { SearchField } from "@heroui/react";

interface HomeHeroSearchProps {
    value: string;
    onChange(value: string): void;
    onSubmit(value: string): void;
    onClear(): void;
}

export const HomeHeroSearch = ({ value, onChange, onSubmit, onClear }: HomeHeroSearchProps) => {
    return (
        <div className="hero-search w-full max-w-xl mx-auto">
            <SearchField
                aria-label="Search recipes"
                value={value}
                onChange={onChange}
                onClear={onClear}
                onSubmit={(submitted) => onSubmit(submitted.trim())}
                fullWidth
            >
                <SearchField.Group>
                    <SearchField.SearchIcon />
                    <SearchField.Input placeholder="Search recipes by name..." />
                    <SearchField.ClearButton />
                </SearchField.Group>
            </SearchField>
        </div>
    );
};
